import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface InboxState {
  isTheatreMode: boolean;
  activeConversationId: string | null;
  isPanelOpen: boolean;
  searchQuery: string;
  toggleTheatreMode: () => void;
  exitTheatreMode: () => void;
  setActiveConversation: (id: string | null) => void;
  togglePanel: () => void;
  setSearchQuery: (q: string) => void;
}

/**
 * Story 25.9 — Theatre/fullscreen mode persisted per-user via localStorage.
 * Other fields (activeConversationId, searchQuery) intentionally NOT persisted
 * (session-scoped).
 */
export const useInboxStore = create<InboxState>()(
  persist(
    (set) => ({
      isTheatreMode: false,
      activeConversationId: null,
      isPanelOpen: true,
      searchQuery: '',

      toggleTheatreMode: () => set((s) => ({ isTheatreMode: !s.isTheatreMode })),
      exitTheatreMode: () => set({ isTheatreMode: false }),
      setActiveConversation: (id) => set({ activeConversationId: id }),
      togglePanel: () => set((s) => ({ isPanelOpen: !s.isPanelOpen })),
      setSearchQuery: (q) => set({ searchQuery: q }),
    }),
    {
      name: 'inbox:store',
      storage: createJSONStorage(() => localStorage),
      // Only persist fullscreen toggle — conversation/query are session-scoped
      partialize: (s) => ({ isTheatreMode: s.isTheatreMode }) as Partial<InboxState>,
    },
  ),
);
